(function () {
  if (!window.customElements || customElements.get('xfun-outfit')) return;

  class XfunOutfit extends HTMLElement {
    connectedCallback() {
      if (this.ready) {
        this.bindProductEvents();
        this.update();
        return;
      }
      if (typeof window.fetch !== 'function') return;
      this.form = this.querySelector('[data-xfo-form]');
      this.choices = Array.from(this.querySelectorAll('[data-xfo-size]'));
      this.button = this.querySelector('[data-xfo-add]');
      this.status = this.querySelector('[data-xfo-status]');
      this.cartLink = this.querySelector('[data-xfo-cart]');
      if (!this.form || this.choices.length !== 2 || !this.button) return;
      this.ready = true;
      this.idleLabel = this.button.textContent;
      this.currency = this.dataset.currency || 'EUR';
      this.locale = this.dataset.locale || 'fr';
      this.pending = false;
      this.completed = false;
      this.uncertain = false;
      this.choices.forEach(select => {
        select.dataset.initialMoney = select.closest('[data-xfo-piece]').querySelector('[data-xfo-price]').textContent;
      });
      this.querySelectorAll('[data-xfo-enhanced]').forEach(node => { node.hidden = false; });
      this.choices.forEach(select => select.addEventListener('change', () => {
        this.completed = false;
        this.status.textContent = this.valid() ? '' : this.dataset.labelMissing;
        if (this.uncertain) this.status.textContent = this.dataset.labelUncertain;
        this.update();
      }));
      this.form.addEventListener('submit', event => this.add(event));
      this.bindProductEvents();
      this.update();
    }

    bindProductEvents() {
      const root = this.closest('[data-xfun-luxe-product]');
      if (this.productRoot === root && this.onProductBusy) return;
      this.unbindProductEvents();
      this.productRoot = root;
      this.onProductBusy = () => this.update();
      if (root) {
        root.addEventListener('xfun:product:pending', this.onProductBusy);
        root.addEventListener('xfun:product:color-loading', this.onProductBusy);
      }
    }

    unbindProductEvents() {
      if (this.productRoot && this.onProductBusy) {
        this.productRoot.removeEventListener('xfun:product:pending', this.onProductBusy);
        this.productRoot.removeEventListener('xfun:product:color-loading', this.onProductBusy);
      }
      this.productRoot = null;
      this.onProductBusy = null;
    }

    disconnectedCallback() {
      this.unbindProductEvents();
    }

    setPending(value) {
      this.pending = value;
      const root = this.productRoot;
      if (root) {
        root.dataset.xfunCartPending = String(value);
        if (root._xfunRefreshPurchase) root._xfunRefreshPurchase();
        root.dispatchEvent(new CustomEvent('xfun:product:pending', {bubbles:true, detail:{pending:value}}));
      }
      this.update();
    }

    selection(select) {
      const option = select.options[select.selectedIndex];
      return option && option.value && !option.disabled ? option : null;
    }

    valid() {
      return this.choices.every(select => Boolean(this.selection(select)));
    }

    money(cents) {
      try {
        return new Intl.NumberFormat(this.locale, {style:'currency', currency:this.currency, minimumFractionDigits:0, maximumFractionDigits:2}).format(cents / 100);
      } catch (_) {
        return (cents / 100).toFixed(2) + ' ' + this.currency;
      }
    }

    update() {
      const root = this.productRoot;
      const busy = this.pending || Boolean(root && (root.dataset.xfunCartPending === 'true' || root.dataset.xfunColorLoading === 'true'));
      let total = 0;
      let totalVaries = false;
      this.choices.forEach(select => {
        const option = this.selection(select);
        total += Number(option ? option.dataset.price : select.dataset.basePrice);
        if (!option && select.dataset.priceVaries === 'true') totalVaries = true;
        select.closest('[data-xfo-piece]').querySelector('[data-xfo-price]').textContent = option ? option.dataset.money : select.dataset.initialMoney;
        select.disabled = busy;
      });
      this.querySelector('[data-xfo-total]').textContent = (totalVaries ? this.dataset.labelFrom + ' ' : '') + this.money(total);
      this.button.disabled = busy || this.completed || this.uncertain || !this.valid();
      this.button.textContent = this.pending ? this.dataset.labelAdding : this.idleLabel;
      this.form.setAttribute('aria-busy', String(busy));
    }

    root() {
      return window.Shopify && Shopify.routes && Shopify.routes.root || '/';
    }

    sectionIds() {
      if (typeof getCartSectionRequestIds === 'function') {
        const ids = getCartSectionRequestIds();
        if (Array.isArray(ids) && ids.length) return ids.slice(0, 5);
      }
      return ['cart-items','cart-footer','cart-item-count','cart-live-region'];
    }

    async refreshCount() {
      try {
        const response = await fetch(this.root() + 'cart.js', {credentials:'same-origin', headers:{Accept:'application/json'}});
        if (!response.ok) return;
        const cart = await response.json();
        if (!Number.isInteger(cart.item_count)) return;
        document.querySelectorAll('[data-xfun-cart-count]').forEach(badge => {
          badge.textContent = String(cart.item_count);
          badge.hidden = cart.item_count === 0;
          badge.style.display = cart.item_count === 0 ? 'none' : '';
        });
        if (window.theme) window.theme.cartItemCount = cart.item_count;
      } catch (_) { /* The successful addition is independent of badge refresh. */ }
    }

    async reconcile(data, ids) {
      const complete = () => data.sections && ids.every(id => typeof data.sections[id] === 'string' && data.sections[id].trim());
      if (!complete()) {
        try {
          const response = await fetch(location.pathname + '?sections=' + encodeURIComponent(ids.join(',')), {credentials:'same-origin', headers:{Accept:'application/json'}});
          if (response.ok) data.sections = Object.assign({}, data.sections || {}, await response.json());
        } catch (_) { /* Cart count still refreshes below. */ }
      }
      if (complete()) {
        document.body.dispatchEvent(new CustomEvent('shapes:cart:afteradditem', {bubbles:true, detail:{response:data, sourceId:this.form.id}}));
      }
      await this.refreshCount();
    }

    async add(event) {
      event.preventDefault();
      const root = this.productRoot;
      if (this.pending || this.completed || this.uncertain || root && (root.dataset.xfunCartPending === 'true' || root.dataset.xfunColorLoading === 'true')) return;
      if (!this.valid()) {
        this.status.textContent = this.dataset.labelMissing;
        this.choices.find(select => !this.selection(select)).focus();
        return;
      }
      const items = this.choices.map(select => ({id:Number(this.selection(select).value), quantity:1}));
      const ids = this.sectionIds();
      const controller = typeof AbortController === 'function' ? new AbortController() : null;
      const timeout = controller ? setTimeout(() => controller.abort(), 20000) : null;
      this.status.textContent = this.dataset.labelAdding;
      this.cartLink.hidden = true;
      this.setPending(true);
      let data;
      try {
        const response = await fetch(this.root() + 'cart/add.js', {
          method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json', Accept:'application/json', 'X-Requested-With':'XMLHttpRequest'},
          body:JSON.stringify({items, sections:ids, sections_url:location.pathname}),
          signal:controller ? controller.signal : undefined
        });
        if (!response.ok) {
          const error = new Error('rejected');
          // A server error can arrive after the write. A multi-item 422 can also
          // leave uncertainty about a partial addition, so do not invite a retry.
          error.confirmedFailure = response.status >= 400 && response.status < 500 && response.status !== 408 && response.status !== 422;
          throw error;
        }
        data = await response.json();
        if (!Array.isArray(data.items) || data.items.length !== 2 || !items.every(item => data.items.some(added => String(added.variant_id || added.id) === String(item.id)))) throw new Error('unconfirmed');
        this.completed = true;
        this.status.textContent = this.dataset.labelAdded;
        this.cartLink.hidden = false;
      } catch (error) {
        this.uncertain = !error.confirmedFailure;
        this.status.textContent = this.uncertain ? this.dataset.labelUncertain : this.dataset.labelError;
        this.cartLink.hidden = false;
      } finally {
        clearTimeout(timeout);
        this.setPending(false);
      }
      // No automatic retry: an interrupted response may already have added the pieces.
      if (this.completed) await this.reconcile(data, ids);
      else await this.refreshCount();
    }
  }

  customElements.define('xfun-outfit', XfunOutfit);
})();
